import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Box
} from '@mui/material';

const AttendanceListSkeleton = ({
  rowsCount = 5,
  periodsCount = 4,
}) => {
  return (
    <Paper sx={{ width: '100%', p: 2, mb: 2 }}>
      <TableContainer>
        <Table>
          <TableHead sx={{ backgroundColor: 'primary.main' }}>
            <TableRow>
              <TableCell sx={{ width: '15em' }}>
                <Skeleton variant="text" width="80%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="60%" />
              </TableCell>
              <TableCell sx={{ width: '13em' }}>
                <Skeleton variant="text" width="70%" />
              </TableCell>

              {Array.from({ length: periodsCount }).map((_, index) => (
                <TableCell key={index}>
                  <Skeleton variant="text" width="60%" />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {Array.from({ length: rowsCount }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                <TableCell>
                  <Skeleton variant="text" width="90%" />
                </TableCell>

                <TableCell>
                  <Skeleton variant="circular" width={24} height={24} />
                </TableCell>

                <TableCell>
                  <Skeleton variant="text" width="85%" />
                </TableCell>

                {Array.from({ length: periodsCount }).map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    <Skeleton variant="rectangular" height={24} sx={{ borderRadius: 1 }} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Box sx={{ px: 2, py: 1 }}>
          <Skeleton variant="rectangular" height={36} width="100%" sx={{ borderRadius: 1 }} />
        </Box>
      </TableContainer>
    </Paper>
  );
};

export default AttendanceListSkeleton;
